<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="inner-wrap">
  <div class="result">
	  <div class="txt"><span>{{findResult.userName}}</span> 님의 아이디는 아래와 같습니다.</div>
	  <div class="id">
	    <p>아이디 <span>{{findResult.userId}}</span></p>
	  </div>
	  <button class="btn1" (click)="goLink()">확인</button>
  </div>
</div>

<app-footer></app-footer>